import { React, useEffect, useState } from "react";
import { Unity, useUnityContext } from "react-unity-webgl";
import { MobileView, BrowserView } from "react-device-detect";

function UnityPlayer({gameUrl}) {
  const buildPath = gameUrl;
  const { unityProvider, sendMessage, addEventListener, removeEventListener } = useUnityContext({
    loaderUrl: `${buildPath}build.loader.js`,
    dataUrl: `${buildPath}build.data`,
    frameworkUrl: `${buildPath}build.framework.js`,
    codeUrl: `${buildPath}build.wasm`,
  });

  return (
    <>
    <BrowserView>
      <Unity unityProvider={unityProvider} 
        style={{ width: '768px', height: "720px" }}
      />
      </BrowserView>
      <MobileView>
      <Unity unityProvider={unityProvider} 
        style={{ width: '512px', height: "480px" }}
      />
      </MobileView>
      </>
  );
}

export default UnityPlayer;